/* eslint-disable */
import CommentEntity from "../Entity/Comment";

let CommentsRepository = Backbone.Collection.extend({
	model: CommentEntity
});

export default CommentsRepository;